import axios from "axios"

export const getAxiosInstanceApi = () => {
	return axios.create({
		baseURL: 'https://api.aref-medical.com',
		headers:{
			'x-center-token':'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjZW50ZXJJZCI6IjE1Iiwicm9sZSI6ImNlbnRlciIsImlhdCI6MTY4Nzk3MDYzNH0.fQPYeO82gbdxnYfnkbFrsnfEN96y3BwbwODGttmMXBU',
			'x-auth-token':sessionStorage.getItem('x-auth-token')
		}
	})
}
